const live = {
    en: {
        live: {
            heading: 'What would you like to do today?',
            tabs: { transcribe: 'Transcribe', translate: 'Translate', dubbing: 'Dubbing' },
            comingSoon: 'Coming soon',
            swap: 'Swap languages',
            twoWay: 'Two-way translation',
            twoWayInfo: 'Both speakers share one mic. Each sentence is translated into the other language automatically.',
            twoWayWebSpeechInfo: 'Browser mode cannot detect the language on its own — tap the button for the side that is speaking.',
            highQuality: 'High quality mode',
            highQualityInfo: 'Uses Gemini live transcription. More accurate and works in every browser, but consumes your daily live minutes.',
            autoSpeak: 'Read translation aloud',
            press: 'Press and start talking',
            listening: 'Listening…',
            stop: 'Stop',
            speaker: 'Speaker {n}',
            empty: 'Your conversation will appear here.',
            minutesLeft: '{seconds}s of live audio left today',
            translating: 'Translating…',
            retry: 'Retry',
            errors: {
                micDenied: 'Microphone access was denied. Allow it in your browser settings and try again.',
                noEngine: 'Real-time speech is not supported in this browser. Please use Chrome or Edge.',
                fellBackToBrowser: 'High quality mode is unavailable, switched to browser speech recognition.',
                translateFailed: 'Could not translate this sentence.',
                sessionFailed: 'The live session stopped unexpectedly.',
            },
        },
    },
    th: {
        live: {
            heading: 'วันนี้อยากทำอะไรดี?',
            tabs: { transcribe: 'ถอดข้อความ', translate: 'แปลภาษา', dubbing: 'พากย์เสียง' },
            comingSoon: 'เร็ว ๆ นี้',
            swap: 'สลับภาษา',
            twoWay: 'แปลสองทาง',
            twoWayInfo: 'ใช้ไมค์ตัวเดียวร่วมกัน ระบบจะแปลแต่ละประโยคไปเป็นอีกภาษาให้อัตโนมัติ',
            twoWayWebSpeechInfo: 'โหมดเบราว์เซอร์ตรวจภาษาเองไม่ได้ — กดปุ่มฝั่งที่กำลังพูด',
            highQuality: 'โหมดคุณภาพสูง',
            highQualityInfo: 'ใช้ Gemini ถอดเสียงแบบเรียลไทม์ แม่นกว่าและใช้ได้ทุกเบราว์เซอร์ แต่จะกินโควตานาทีต่อวัน',
            autoSpeak: 'อ่านคำแปลออกเสียง',
            press: 'กดแล้วเริ่มพูดได้เลย',
            listening: 'กำลังฟัง…',
            stop: 'หยุด',
            speaker: 'คนที่ {n}',
            empty: 'บทสนทนาจะแสดงที่นี่',
            minutesLeft: 'เหลือเวลาพูดวันนี้ {seconds} วินาที',
            translating: 'กำลังแปล…',
            retry: 'ลองใหม่',
            errors: {
                micDenied: 'ไม่ได้รับสิทธิ์ใช้ไมโครโฟน กรุณาอนุญาตในตั้งค่าเบราว์เซอร์แล้วลองใหม่',
                noEngine: 'เบราว์เซอร์นี้ไม่รองรับการพูดแบบเรียลไทม์ กรุณาใช้ Chrome หรือ Edge',
                fellBackToBrowser: 'ใช้โหมดคุณภาพสูงไม่ได้ สลับไปใช้การรู้จำเสียงของเบราว์เซอร์แทน',
                translateFailed: 'แปลประโยคนี้ไม่สำเร็จ',
                sessionFailed: 'เซสชันถอดเสียงหยุดกลางคัน',
            },
        },
    },
};

export default live;
